export default class EligibilityCheckError extends Error {
    constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, EligibilityCheckError.prototype);
    }
}